import CalendarView from './CalenderView';
import FMMap from '../../../FMMap';
import FMTable from '../../../FMTable';


const RenderContentView = ({
  style,
  rows,
  conversation,
  messageType,
  options,
  message,
  parentTabId,
  parentDocId,
  inContainer,
  handleAction,
}) => {
  switch (style) {
    case 'calendar':
      return (
        <CalendarView
          conversation={conversation}
          messageType={messageType}
          parentTabId={parentTabId}
          parentDocId={parentDocId}
          options={options}
          message={message || rows}
        />
      );
    case 'map': {
      const mapContainer = options.parent
        ? `map-holder-${parentTabId}-${options.tabId}`
        : `map-holder-${options.tabId}`;
      return (
        <div className="relative 2xl:h-full">
          <FMMap
            noFullScreencontrol={false}
            conversation={conversation}
            handleAction={handleAction}
            messageType={messageType}
            parentTabId={parentTabId}
            parentDocId={parentDocId}
            inContainer={inContainer || false}
            options={options}
            message={message || rows}
            mapContainer={mapContainer}
            mapCssStyles={{
              position: 'absolute',
              left: '0px',
              right: '0px',
              borderRadius: '15px',
            }}
          />
        </div>
      );
    }
    default:
      return (
        <FMTable
          conversation={conversation}
          messageType={messageType}
          parentTabId={parentTabId}
          parentDocId={parentDocId}
          options={options}
          message={message || rows}
        />
      );
  }
};

export default RenderContentView;
